/**
 * Shared resolution of the effective annual expense that drives the FI target,
 * the investable line, and the FI prompt/validity. Centralizing this keeps the
 * chart's `showInvestable` gate and the section's prompt from diverging.
 *
 * The override (an explicit user value) wins; otherwise the projection's applied
 * value is used. The `fallback` argument lets each call site keep its own
 * null-vs-0 semantics: the chart wants a nullable number, the editable value
 * wants a concrete 0.
 */
export function resolveEffectiveAnnualExpenses(
    annualExpensesOverride: number | null | undefined,
    appliedAnnualExpenses: number | null | undefined,
    fallback: null,
): number | null;
export function resolveEffectiveAnnualExpenses(
    annualExpensesOverride: number | null | undefined,
    appliedAnnualExpenses: number | null | undefined,
    fallback: number,
): number;
export function resolveEffectiveAnnualExpenses(
    annualExpensesOverride: number | null | undefined,
    appliedAnnualExpenses: number | null | undefined,
    fallback: number | null,
): number | null {
    return annualExpensesOverride ?? appliedAnnualExpenses ?? fallback;
}

/**
 * Whether the resolved annual expense can drive an FI projection. A valid
 * expense must be present and strictly positive.
 */
export function hasValidFiExpense(
    annualExpensesOverride: number | null | undefined,
    appliedAnnualExpenses: number | null | undefined,
): boolean {
    const value = resolveEffectiveAnnualExpenses(annualExpensesOverride, appliedAnnualExpenses, null);
    return value != null && value > 0;
}
